import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { delayRetrieveRecords } from '../store/actions/search';
import { changeAddressFilter } from '../store/actions/query';
import { getAddressFilter } from '../store/selectors/query';
import { getStateOptions } from '../store/selectors/static';
import { isPresent } from 'helpers/string_helpers';

import CityFilter from 'components/research_property/city_filter';
import FilterButton from 'components/ui/filter_button';
import FilterInput from 'components/search_sidebar/filter_input';
import FilterSelect from 'components/search_sidebar/filter_select';

export class AddressFilter extends React.Component {
  static propTypes = {
    addressFilter: PropTypes.shape({
      cities: PropTypes.array,
      currentCity: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string
    }),
    delayRetrieveRecords: PropTypes.func.isRequired,
    stateOptions: PropTypes.array.isRequired,
    onAddressFilterChange: PropTypes.func.isRequired,
  }

  handleAddressFilterChange = (e, name) => {
    const { addressFilter, onAddressFilterChange, delayRetrieveRecords } = this.props;
    if (name == "cities") {
      let cities = [];

      if (addressFilter[name].includes(e)) {
        addressFilter[name] = addressFilter[name].filter(cities => cities !== e);
      } else {
        cities = [...addressFilter[name], e];
        addressFilter[name] = cities;
        addressFilter["currentCity"] = "";
      }
    } else {
      const value = e ? e.target.value : "";
      addressFilter[name] = value;
    }

    onAddressFilterChange(addressFilter);
    delayRetrieveRecords();
  }

  render() {
    const { addressFilter: { cities, state, zip, currentCity }, stateOptions } = this.props;

    return (
      <FilterButton
        filtersApplied={cities.length > 0 || isPresent(state) || isPresent(zip)}
        label="Location"
        name="location"
      >
        <div className="d-flex flex-column gap-2">
          <CityFilter
            cities={cities}
            currentCity={currentCity}
            onChange={this.handleAddressFilterChange}
          />
          <FilterSelect
            defaultValue=""
            label="State"
            name={`state-filter`}
            options={stateOptions}
            placeholder="Select a State"
            value={state}
            onChange={e => this.handleAddressFilterChange(e, "state")}
          />
          <FilterInput
            label="Zip Code"
            name="zip-filter"
            value={zip}
            onChange={e => this.handleAddressFilterChange(e, 'zip')}
          />
        </div>
      </FilterButton>
    );
  }
}

const mapStateToProps = state => ({
  addressFilter: getAddressFilter(state),
  stateOptions: getStateOptions(state)
});

const mapDispatchToProps = {
  delayRetrieveRecords,
  onAddressFilterChange: changeAddressFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressFilter);
